// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"3d50e09c","361":"8195c649","511":"40f80c79","767":"6e28f250"}[chunkId] + ".chunk.js";
};